import React, { useEffect, useState, memo } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://little-genius-system.impultienda.ar/checkout';
const PRICE = 27;
export function PricingSection() {
  const fadeIn = useFadeIn();
  const [timeLeft, setTimeLeft] = useState(85408);
  useEffect(() => {
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const volumes = [{
    emoji: '📘',
    text: 'Volume 1 — Attention & Focus Training Center'
  }, {
    emoji: '📗',
    text: 'Volume 2 — Memory Booster Lab'
  }, {
    emoji: '📙',
    text: 'Volume 3 — Learning Skills Workshop'
  }, {
    emoji: '📕',
    text: 'Volume 4 — Thinking & Problem Solving Center'
  }, {
    emoji: '📒',
    text: 'Volume 5 — Calm & Self-Control Academy'
  }, {
    emoji: '📓',
    text: 'Volume 6 — Brain Power Playground'
  }];
  const volumeFeatures = ['Simple, progressive and fun brain-building activities', 'Exercises designed to develop real cognitive skills', 'A screen-free alternative your child will actually ask for', 'Skill-by-skill growth that builds week after week'];
  const bonuses = [{
    emoji: '🧳',
    text: 'Bonus 1 — Brain Games Travel Kit'
  }, {
    emoji: '🔓',
    text: 'Bonus 2 — Brain Escape Room'
  }, {
    emoji: '🕵️',
    text: 'Bonus 3 — Brain Detective Academy'
  }, {
    emoji: '👨‍👩‍👧‍👦',
    text: 'Bonus 4 — Family Brain Night'
  }, {
    emoji: '🔬',
    text: 'Bonus 5 — Junior Inventor Lab'
  }];
  const totalDisplay = PRICE.toFixed(2);
  return <section id="pricing" className="py-10 md:py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-148">
      <div className="max-w-3xl mx-auto" data-id="element-149">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-150">
          {/* Countdown Block */}
          <div className="text-center mb-8 md:mb-10" data-id="element-151">
            <div className="inline-flex items-center gap-2 bg-red-900/60 border border-red-500/40 text-red-300 font-bold text-xs md:text-base px-4 py-2 md:px-5 md:py-2 rounded-full mb-5 md:mb-6" data-id="element-152">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-153" />
              <span data-id="element-154">OFFER ENDS IN:</span>
            </div>

            <div className="flex items-center justify-center gap-2 md:gap-3 mb-5 md:mb-6" data-id="element-155">
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-156">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-157">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-158">
                  hrs
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-red-400" data-id="element-159">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-160">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-161">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-162">
                  min
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-red-400" data-id="element-163">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-164">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-165">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-166">
                  sec
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-xs md:text-base" data-id="element-167">
              <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-168" />
              <span data-id="element-169">
                The price will return to $97.00 once this special 12,000-family
                celebration discount ends.
              </span>
            </div>
          </div>

          {/* Single Offer Card */}
          <div className="relative bg-gradient-to-b from-[#0d0d1a] to-[#111122] border-2 border-yellow-400 rounded-3xl p-6 md:p-10 shadow-2xl" data-id="element-170">
            {/* Limited time ribbon */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-10" data-id="element-171">
              <span className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white text-sm md:text-base font-black px-5 md:px-7 py-2 md:py-2.5 rounded-full uppercase tracking-wider shadow-xl whitespace-nowrap" data-id="element-172">
                🎉 LIMITED TIME OFFER
              </span>
            </div>

            {/* Intro */}
            <div className="mt-4 mb-6 md:mb-8 text-center" data-id="element-173">
              <p className="text-base md:text-xl text-gray-300 font-medium leading-relaxed" data-id="element-174">
                ✅ You're one step away from giving your child{' '}
                <span className="text-yellow-400 font-black" data-id="element-175">
                  The Little Genius System™
                </span>
                , a complete, screen-free brain-training system inspired by
                Montessori and cognitive development principles — designed to
                build focus, memory and confidence.
              </p>
            </div>

            {/* What's included */}
            <div className="mb-6 md:mb-8" data-id="element-176">
              <h3 className="text-lg md:text-2xl font-black text-white mb-4 md:mb-5 text-center" data-id="element-177">
                🎁 Everything You Get Today:
              </h3>

              <p className="text-sm md:text-base text-yellow-300 font-bold mb-3 md:mb-4" data-id="element-178">
                6 Digital Volumes packed with progressive brain-building
                activities:
              </p>
              <div className="grid grid-cols-1 gap-2.5 mb-5 md:mb-6" data-id="element-179">
                {volumes.map((b, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3 md:p-3.5" data-id="element-180">
                    <span className="text-xl md:text-2xl flex-shrink-0" data-id="element-181">
                      {b.emoji}
                    </span>
                    <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-182">
                      {b.text}
                    </p>
                  </div>)}
              </div>

              <p className="text-sm md:text-base text-blue-300 font-bold mb-2 md:mb-3" data-id="element-183">
                ✨ Every volume includes:
              </p>
              <ul className="space-y-1.5 md:space-y-2 mb-5 md:mb-6 pl-2" data-id="element-184">
                {volumeFeatures.map((f, i) => <li key={i} className="flex items-start gap-2 text-sm md:text-base text-gray-400" data-id="element-185">
                    <span className="text-green-400 mt-0.5 flex-shrink-0" data-id="element-186">
                      ✓
                    </span>
                    <span data-id="element-187">{f}</span>
                  </li>)}
              </ul>

              <p className="text-sm md:text-base text-yellow-300 font-bold mb-3 md:mb-4" data-id="element-188">
                🎁 Plus 5 free bonuses included today:
              </p>
              <div className="grid grid-cols-1 gap-2.5" data-id="element-189">
                {bonuses.map((b, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3" data-id="element-190">
                    <span className="text-lg md:text-xl flex-shrink-0" data-id="element-191">
                      {b.emoji}
                    </span>
                    <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-192">
                      {b.text}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Price block */}
            <div className="bg-[#0a0a14] border-2 border-yellow-400/50 rounded-2xl p-5 md:p-8 mb-6 md:mb-8 text-center" data-id="element-193">
              <p className="text-sm md:text-base text-gray-400 line-through mb-2" data-id="element-194">
                Total Value: $192.00 USD
              </p>
              <p className="inline-block bg-red-600 text-white text-xs md:text-sm font-black px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-195">
                TODAY ONLY
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-196">
                <span className="text-sm md:text-base text-gray-400 font-medium" data-id="element-197">
                  USD
                </span>
                <span className="text-5xl md:text-7xl font-black text-yellow-400" data-id="element-198">
                  ${totalDisplay}
                </span>
              </div>
              <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-199">
                310 Pages · Instant Download · Unlimited Printing · Lifetime
                Access
              </p>
            </div>

            {/* CTA */}
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full" onClick={() => {
            const w = window as any;
            if (w.fbq) {
              w.fbq('track', 'InitiateCheckout', {
                value: PRICE,
                currency: 'USD',
                num_items: 1
              });
            }
          }} data-id="element-200">
              <div className="relative w-full group cta-pulse" data-id="element-201">
                <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-xl opacity-70 md:group-hover:opacity-100 transition duration-200" data-id="element-202"></div>
                <div className="relative w-full text-center font-black text-base md:text-2xl uppercase tracking-wide py-4 md:py-5 rounded-xl bg-gradient-to-b from-yellow-400 to-yellow-500 border-b-4 border-yellow-700 text-black shadow-2xl" data-id="element-203">
                  👉 YES, I WANT THE LITTLE GENIUS SYSTEM™ — ${totalDisplay}
                </div>
              </div>
            </a>

            <div className="flex flex-col items-center justify-center gap-2 mt-5 text-gray-500 text-xs md:text-sm" data-id="element-204">
              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4" data-id="element-205">
                <span data-id="element-206">🔒 100% Secure Checkout</span>
                <span data-id="element-207">•</span>
                <span data-id="element-208">⚡ Instant Delivery</span>
                <span data-id="element-209">•</span>
                <span data-id="element-210">🛡️ 7-Day Guarantee</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}